import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { IdCard, Sparkles, HandHeart, Plus } from "lucide-react";

export default function Dashboard() {
  const { user, authLoading } = useApp();
  const nav = useNavigate();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    if (!authLoading && !user) nav("/login");
  }, [authLoading, user, nav]);

  useEffect(() => {
    if (user) api.get("/me/idcards").then(({ data }) => setCards(data)).catch(() => {});
  }, [user]);

  if (!user) return null;

  return (
    <div className="max-w-6xl mx-auto px-6 py-10" data-testid="dashboard-page">
      <div className="flex items-center gap-4 mb-8">
        {user.picture ? <img src={user.picture} alt="" className="w-14 h-14 rounded-full ring-2 ring-pink-200" /> : null}
        <div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Hi {user.name.split(" ")[0]}!</h1>
          <p className="text-slate-600 text-sm">Member of Zi Zi's World</p>
        </div>
        <div className="ml-auto card-soft px-4 py-2 text-center">
          <div className="text-xs text-slate-500">Points</div>
          <div className="font-display text-2xl font-bold text-pink-600">{user.points}</div>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        <Link to="/id-card" data-testid="dash-new-card" className="card-soft p-5 group">
          <IdCard className="h-6 w-6 text-pink-500" />
          <h3 className="font-display font-bold mt-2 group-hover:text-pink-600">New ID Card</h3>
        </Link>
        <Link to="/shop" className="card-soft p-5 group">
          <Sparkles className="h-6 w-6 text-pink-500" />
          <h3 className="font-display font-bold mt-2 group-hover:text-pink-600">Shop Essentials</h3>
        </Link>
        <Link to="/fundraisers/new" className="card-soft p-5 group">
          <HandHeart className="h-6 w-6 text-pink-500" />
          <h3 className="font-display font-bold mt-2 group-hover:text-pink-600">Start Fundraiser</h3>
        </Link>
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">My ID Cards</h2>
      {cards.length === 0 ? (
        <div className="card-soft p-8 text-center">
          <p className="text-slate-600">No saved ID cards yet.</p>
          <Link to="/id-card" className="btn-pink mt-4 inline-flex items-center gap-1"><Plus className="h-4 w-4" /> Create one</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map((c) => (
            <Link key={c.card_id} to={`/emergency/${c.card_id}`} data-testid={`card-${c.card_id}`} className="card-soft p-5">
              <div className="flex items-center gap-3">
                {c.photo_data_url ? <img src={c.photo_data_url} alt="" className="w-12 h-12 rounded-xl object-cover" /> : <div className="w-12 h-12 rounded-xl bg-pink-100" />}
                <div>
                  <div className="font-bold text-slate-900">{c.child_name}</div>
                  <div className="text-xs text-slate-500">{c.diagnosis}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
